import cn from "clsx";
import { Button } from "@components/ui";
import Image from "next/image";
import React, { FC, useState } from "react";
import ImgIconFilter from "@static/images/icons/icon-filter2.png";
import { useTranslation } from "next-i18next";
import { ModalFilter } from "../../ModalFiltres/ModalFiltres";
import style from "./FilterButton.module.scss";

interface Props {
  sticky: boolean;
  tabLabel?: string;
  toggle: (codes: string[]) => void;
  selectedFilters: Set<string>;
  variant?: "alc" | "meal";
  isOptimum?: boolean;
}
export const FilterButton: FC<Props> = ({
  sticky,
  tabLabel,
  toggle,
  selectedFilters,
  variant = "meal",
  isOptimum,
}) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const filtersLength = selectedFilters.size;

  return (
    <>
      <div
        className={cn(style.actions, style[variant], {
          [style.sticky]: sticky,
        })}
      >
        <Button
          type="button"
          variant="default"
          onClick={() => setIsOpen(true)}
          outline={true}
        >
          {filtersLength <= 0 ? (
            <span>{t("programs.filterMeals")}</span>
          ) : (
            <span>
              {t("programs.filters", { count: selectedFilters.size })}
            </span>
          )}
          <Image src={ImgIconFilter} alt="" />
        </Button>
      </div>
      <ModalFilter
        selectedFilters={selectedFilters}
        toggle={toggle}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        isOptimum={isOptimum}
      />
    </>
  );
};
